var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeCloseGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 265,
    height: 265,
    viewBox: "0 0 265 265",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6638_8082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.088 198.087C179.213 212.474 156.23 220.445 132.5 220.833C55.2087 220.833 11.042 132.5 11.042 132.5C24.7766 106.904 43.8262 84.5413 66.9128 66.9121M109.313 46.8163C116.913 45.0373 124.695 44.148 132.5 44.1663C209.792 44.1663 253.959 132.5 253.959 132.5C247.256 145.039 239.263 156.844 230.109 167.723M155.909 155.908C152.876 159.162 149.219 161.773 145.156 163.583C141.092 165.394 136.706 166.367 132.258 166.446C127.811 166.524 123.393 165.706 119.268 164.04C115.143 162.374 111.397 159.894 108.251 156.749C105.106 153.603 102.626 149.856 100.96 145.732C99.2939 141.607 98.4757 137.189 98.5542 132.742C98.6327 128.294 99.6062 123.908 101.417 119.844C103.227 115.781 105.837 112.124 109.092 109.091",
    stroke: "#949494",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.042 11.042L253.959 253.959",
    stroke: "#949494",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6638_8082"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 265,
    height: 265,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeCloseGray);
export default __webpack_public_path__ + "static/media/eye_close_gray.636ba5e03ba7373dd094eb16c37d4fa2.svg";
export { ForwardRef as ReactComponent };